import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { supabase } from '../lib/supabase';

let deepLinkHandled = false;

async function handleAuthUrl(url: string) {
  if (deepLinkHandled) return;

  const isAuthCallback =
    url.includes('access_token') ||
    url.includes('code=') ||
    url.includes('login-callback') ||
    url.includes('auth/callback');

  if (!isAuthCallback) return;

  deepLinkHandled = true;
  console.log('[DeepLink] Processing auth callback:', url);

  try {
    const hashPart = url.split('#')[1];
    const queryPart = url.split('?')[1];
    const params = new URLSearchParams(hashPart || queryPart || '');
    const accessToken = params.get('access_token');
    const refreshToken = params.get('refresh_token');

    if (accessToken && refreshToken) {
      console.log('[DeepLink] Tokens found, setting session...');
      const { data, error } = await supabase.auth.setSession({
        access_token: accessToken,
        refresh_token: refreshToken,
      });
      console.log('[DeepLink] setSession result:', !!data.session, error?.message);
    } else if (params.get('code')) {
      console.log('[DeepLink] Code found, exchanging...');
      const { data, error } = await supabase.auth.exchangeCodeForSession(
        params.get('code')!
      );
      console.log('[DeepLink] exchangeCode result:', !!data.session, error?.message);
    } else {
      console.log('[DeepLink] No tokens/code, refreshing session...');
      await supabase.auth.getSession();
    }
  } catch (e) {
    console.error('[DeepLink] Error:', e);
  }

  setTimeout(() => { deepLinkHandled = false; }, 3000);
}

// 1. Capacitor App plugin listener (normal flow)
if (Capacitor.isNativePlatform()) {
  App.addListener('appUrlOpen', ({ url }) => {
    console.log('[DeepLink] appUrlOpen:', url);
    handleAuthUrl(url);
  });
  console.log('[DeepLink] appUrlOpen listener registered');
}

// 2. Custom window event from MainActivity.java (fallback for cold start)
window.addEventListener('deepLinkOpen', ((e: CustomEvent) => {
  const url = e.detail?.url;
  if (url) {
    console.log('[DeepLink] Custom event deepLinkOpen:', url);
    handleAuthUrl(url);
  }
}) as EventListener);

console.log('[DeepLink] All listeners registered');
